import {
  createDraftSafeSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from '@src/redux/store';
import getProjectListThunk from './projectListThunk';
import { InitialState, ProjectListReturn } from '../types/index';

const initialState: InitialState = {
  isLoading: false,
  projects: [],
  getListParams: {
    page: 1,
    limit: 20,
    sortBy: undefined,
    searchBy: 'name',
    search: '',
    filter: {
      type: undefined,
      status: undefined,
      items: { country: undefined },
    },
  },
  meta: {
    currentPage: 0,
    itemsPerPage: 20,
    sortBy: [],
    totalItems: 0,
    totalPages: 0,
  },
};

const projectListSlice = createSlice({
  name: 'projecyList',
  initialState,
  reducers: {
    onSelectedPageNumChange: (state, { payload }) => {
      state.getListParams.page = payload;
    },
    onChangeFilterData: (state, { payload }) => {
      state.getListParams.filter = payload;
    },
    onChangeSearchBy: (state, { payload }) => {
      state.getListParams.searchBy = payload;
    },
    onChangeSearch: (state, { payload }) => {
      state.getListParams.search = payload;
    },
  },
  extraReducers: ({ addCase }) => {
    addCase(getProjectListThunk.pending, (state) => {
      state.isLoading = true;
    })
      .addCase(
        getProjectListThunk.fulfilled,
        (state, { payload }: PayloadAction<ProjectListReturn>) => {
          state.isLoading = false;

          const tmpData = payload.data.map((element) => {
            const tmpCountry = element.campaigns
              .filter((element) => element.recruitInfluencer !== 0)
              .map((item) => item.country);
            const tmpCompanyName = element.company.name;

            return {
              id: element.id,
              serviceId: element.serviceId,
              name: element.name,
              companyName: tmpCompanyName,
              brandKo: element.brandKo,
              brandEn: element.brandEn,
              type: element.type,
              country: tmpCountry,
              status: element.status,
              createdAt: element.createdAt,
              mainAdminUser: element.mainAdminUser,
              company: element.company,
            };
          });

          state.projects = tmpData;
          state.meta = payload.meta;
        }
      )
      .addCase(getProjectListThunk.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const {
  onSelectedPageNumChange,
  onChangeFilterData,
  onChangeSearchBy,
  onChangeSearch,
} = projectListSlice.actions;

export default projectListSlice.reducer;

const selfSelector = (state: RootState) => state.projectList;
export const projectListSelector = createDraftSafeSelector(
  selfSelector,
  (state) => state
);
